import PropTypes from 'prop-types';
import React from 'react';
import { FDLabelText } from '@facet-wealth/design';

const ChangeHistoryText = ({ value }) => {
  return <FDLabelText size={'lg'} value={value ?? ''} />;
};

ChangeHistoryText.propTypes = {
  value: PropTypes.string.isRequired,
};

export default ChangeHistoryText;
